/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Dimension_Workflow_CompletenessInputs */

const en_directory_agent_readiness_dimension_workflow_completeness = /** @type {(inputs: Directory_Agent_Readiness_Dimension_Workflow_CompletenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow completeness`)
};

const zh_directory_agent_readiness_dimension_workflow_completeness = /** @type {(inputs: Directory_Agent_Readiness_Dimension_Workflow_CompletenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作流完整度`)
};

/**
* | output |
* | --- |
* | "Workflow completeness" |
*
* @param {Directory_Agent_Readiness_Dimension_Workflow_CompletenessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_dimension_workflow_completeness = /** @type {((inputs?: Directory_Agent_Readiness_Dimension_Workflow_CompletenessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Dimension_Workflow_CompletenessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_dimension_workflow_completeness(inputs)
	return zh_directory_agent_readiness_dimension_workflow_completeness(inputs)
});
export { directory_agent_readiness_dimension_workflow_completeness as "directory.agent_readiness.dimension.workflow_completeness" }